import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import {
  Calendar,
  Printer,
  ShoppingCart,
  Truck,
  User,
  ArrowLeft,
  CreditCard,
} from "lucide-react";
import { Textarea } from "../../components/ui/textarea";
import productimg from "../../product-01-330x440.png";
import productimg1 from "../../product-02-330x440.png";
import productimg2 from "../../product-03-330x440.png";
import { Link } from "react-router-dom";
const order = {
  id: "3453012",
  date: "Wed, Aug 13, 2020, 4:34PM",
  customer: {
    name: "John Alexander",
    email: "alex@example.com",
    phone: "+998 99 22123456",
    profileUrl: "#",
  },
  shipping: {
    method: "Fargo express",
    paymentMethod: "card",
    status: "new",
    infoUrl: "#",
  },
  delivery: {
    city: "Tashkent, Uzbekistan",
    address: "Block A, House 123, Floor 2",
    poBox: "Po Box 10000",
    profileUrl: "#",
  },
  payment: {
    method: "Master Card **** ****4768",
    business: "Grand Market LLC",
    phone: "+1 (800) 555-154-52",
  },
  products: [
    {
      img: productimg,
      name: "Products1",
      price: 44.25,
      qty: 2,
    },
    {
      img: productimg1,
      name: "Product2",
      price: 7.5,
      qty: 2,
    },
    {
      img: productimg2,
      name: "Product3",
      price: 43.5,
      qty: 2,
    },
  ],
  subtotal: 973.35,
  shippingCost: 10.0,
  total: 983.0,
  paymentStatus: "Payment done",
};
function OrderDetails() {
  return (
    <>
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <Link to="/adminorders">
            <Button variant="outline" size="sm">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-slate-900 mb-1">
              Order Details
            </h1>
            <p className="text-gray-600">
              Detailed view of the customer's order including product items,
              shipping information, payment status, and delivery address
            </p>
          </div>
        </div>
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between mb-2">
              <div>
                <div className="text-gray-500 flex items-center gap-2">
                  <span>
                    <Calendar />
                  </span>
                  <p className="text-sm text-gray-500">
                    <b>{order.date}</b>
                    <br></br>
                    <span className="text-sm text-gray-400"></span>Order ID:
                    {order.id}
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <Select>
                  <SelectTrigger className="w-40">
                    <SelectValue placeholder="Change status" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="new">New</SelectItem>
                    <SelectItem value="shipped">Shipped</SelectItem>
                    <SelectItem value="done">Done</SelectItem>
                  </SelectContent>
                </Select>
                <Button>Save</Button>
                <Button variant="outline">
                  <span role="img" aria-label="print">
                    <Printer />
                  </span>
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 border-b pb-3 mb-3">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="rounded-full bg-blue-100 p-2">
                    <User />
                  </span>
                  <span className="font-semibold">Customer</span>
                </div>
                <div>{order.customer.name}</div>
                <div className="text-gray-500 text-sm">
                  {order.customer.email}
                </div>
                <div className="text-gray-500 text-sm">
                  {order.customer.phone}
                </div>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="rounded-full bg-blue-100 p-2">
                    <Truck />
                  </span>
                  <span className="font-semibold">Order info</span>
                </div>
                <div className="text-sm text-gray-500">
                  Shipping: {order.shipping.method}
                </div>
                <div className="text-sm text-gray-500">
                  Pay method: {order.shipping.paymentMethod}
                </div>
                <div className="text-sm text-gray-500">
                  Status: {order.shipping.status}
                </div>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="rounded-full bg-blue-100 p-2">
                    <Truck />
                  </span>
                  <span className="font-semibold">Deliver to</span>
                </div>
                <div className="text-sm text-gray-500">
                  City: {order.delivery.city}
                </div>
                <div className="text-sm text-gray-500">
                  {order.delivery.address}
                </div>
                <div className="text-sm text-gray-500">
                  {order.delivery.poBox}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
              <div className="md:col-span-2">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Product</TableHead>
                      <TableHead>Unit Price</TableHead>
                      <TableHead>Quantity</TableHead>
                      <TableHead>Total</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {order.products.map((prod, idx) => (
                      <TableRow key={idx}>
                        <TableCell>
                          <div className="flex items-center gap-2">
                            <div className="custom-bg px-2 py-2">
                              <img
                                src={prod.img}
                                alt={prod.name}
                                className="w-6 object-cover rounded"
                              />
                            </div>

                            <span>{prod.name}</span>
                          </div>
                        </TableCell>
                        <TableCell>${prod.price.toFixed(2)}</TableCell>
                        <TableCell>{prod.qty}</TableCell>
                        <TableCell>
                          ${(prod.price * prod.qty).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))}

                    {/* Summary rows */}
                    <TableRow className="no-border-row">
                      <TableCell
                        colSpan={3}
                        className="text-right font-semibold"
                      >
                        Subtotal:
                      </TableCell>
                      <TableCell>${order.subtotal.toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow className="no-border-row">
                      <TableCell
                        colSpan={3}
                        className="text-right font-semibold"
                      >
                        Shipping cost:
                      </TableCell>
                      <TableCell>${order.shippingCost.toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow className="no-border-row">
                      <TableCell
                        colSpan={3}
                        className="text-right font-bold text-md"
                      >
                        Grand total:
                      </TableCell>
                      <TableCell className="font-bold text-md">
                        ${order.total.toFixed(2)}
                      </TableCell>
                    </TableRow>
                    <TableRow className="no-border-row">
                      <TableCell
                        colSpan={3}
                        className="text-right font-semibold"
                      >
                        Status:
                      </TableCell>
                      <TableCell className="p-2">
                        <Badge className="!bg-green-100 !text-green-600">
                          {order.paymentStatus}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              <div>
                <Card className="mb-6">
                  <CardHeader>
                    <CardTitle>Payment info</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center gap-2 mb-2">
                      <span role="img" aria-label="mastercard">
                        <CreditCard />
                      </span>
                      <span>{order.payment.method}</span>
                    </div>
                    <div className="text-sm text-gray-500">
                      Business name: {order.payment.business}
                    </div>
                    <div className="text-sm text-gray-500">
                      Phone: {order.payment.phone}
                    </div>
                  </CardContent>
                </Card>
                <div className="mb-4">
                  <div className="font-semibold mb-2">NOTES</div>
                  <Textarea placeholder="Type some note" />
                  <Button className="mt-2">Save Note</Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
export default OrderDetails;
